"use strict";
//
// These types are used to insert data into an enum
// database column. When adding new types please remember
// to update the database schema for file_ref.ref_type.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    LESSON: 'lesson',
    USER: 'user',
    PACKAGE: 'package',
    MESSAGE: 'message',
    ADMISSION_OFFER: 'admission_offer',
    ACADEMIC: 'academic',
    APPLICATION: 'application',
};
//# sourceMappingURL=fileRefType.js.map